module.exports = __webpack_public_path__ + "1_0_64/img/backspace.7f99dabe.svg";